import { z } from 'zod'
import { ApiLocale, Identity } from '~library/enums'
import { enumWithEmpty } from '~library/models'

export const loginAnalyzeSchema = z.object({
  /** 身份 */
  identity: enumWithEmpty(Identity),
  /** 企業英文名 */
  englishName: z.string(),
  /** 企業代碼 */
  bizId: z.string(),
  /** 企業名稱 */
  localName: z.string(),
  /** 語系 */
  lang: z.nativeEnum(ApiLocale)
})

export interface LoginAnalyze extends z.infer<typeof loginAnalyzeSchema> {}
